import React from 'react';
import './tbilisi/tbilisi.scss';
import { translate } from "react-translate";
import Navbar from './navbar/navbar';
import Block from './block/block';
import Footer from './footer/footer';

import tbilisi1 from '../images/tbilisi1.jpg';
import tbilisi2 from '../images/tbilisi2.jpg';
import tbilisi3 from '../images/tbilisi3.jpg';
import tbilisi4 from '../images/tbilisi4.jpg';
import tbilisi5 from '../images/tbilisi5.jpg';
import tbilisi6 from '../images/tbilisi6.jpg';
import tbilisi7 from '../images/tbilisi7.jpg';

class TbilisiPage extends React.Component {

  render() {
    return (
      <div className="page tbilisi">
        <Navbar commonProps={this.props.commonProps} />
        <h3 className="page_title capsFont">{ this.props.t('title') }</h3>
        <Block whiteBG={true} title={this.props.t('block1_title')} body={this.props.t('block1_body')} imageAlign="left" image={tbilisi1} />
        <Block title={this.props.t('block2_title')} body={this.props.t('block2_body')} imageAlign="right" image={tbilisi2} />
        <Block whiteBG={true} title={this.props.t('block3_title')} body={this.props.t('block3_body')} imageAlign="left" image={tbilisi3} />        
        <Block title={this.props.t('block4_title')} body={this.props.t('block4_body')} imageAlign="right" image={tbilisi4} />
        <Block whiteBG={true} title={this.props.t('block5_title')} body={this.props.t('block5_body')} imageAlign="left" image={tbilisi5} />        
        <Block title={this.props.t('block6_title')} body={this.props.t('block6_body')} imageAlign="right" image={tbilisi6} />        
        <Block whiteBG={true} title={this.props.t('block7_title')} body={this.props.t('block7_body')} imageAlign="left" image={tbilisi7} />                
        <Footer />
      </div>
    );
  }

}

export default translate('TbilisiPage')(TbilisiPage);
